import React from 'react';
import '../../App.css';

export default function porqueSeCadastrar() {
    return <>
        <body className='porque-se-cadastrar'>
            <h1 className='title'>Import&acirc;ncia da doa&ccedil;&atilde;o de sangue </h1>
            <p className='texto'>
                A transfus&atilde;o de sangue entre animais de companhia &eacute; um processo seguro, mas que apenas &eacute; indicado em &uacute;ltimo caso;
            </p>
            <p className='texto'>
                Pacientes que buscam doadores precisam encontr&aacute;-los com urg&ecirc;ncia, cada minuto conta!
            </p>

            <h2 className='title'>Benef&iacute;cios</h2>
            <p className='texto'>
                - Di&aacute;ria em Daycare
            </p>

            <p className='texto'>
                - Check up completo no momento da doa&ccedil;&atilde;o
            </p>

            <p className='texto'>
                - Atualiza&ccedil;&atilde;o de carteira de vacina e vermifuga&ccedil;&atilde;o
            </p>

            <p className='texto'>
                - Teste FIV e FELV
            </p>
        </body>
    </>;
}


        
        
        
        
